import $ from 'jquery';
import 'jquery-touchswipe';
import 'jquery.easing';

import 'lib/bootstrap';
import 'lib/clipboard';
import 'lib/storage';
import 'lib/template';
import 'lib/graphql';
import 'lib/auth';
import 'lib/ajax';
import 'lib/query';
import 'lib/websockets';
import 'lib/notifications';
import 'lib/logrocket';
import 'lib/sidekick';
import 'lib/scanner';
import 'lib/breadcrumb';
import 'lib/notfound';
import 'lib/modal';
import 'lib/toastr';
import 'lib/throttle';
import 'lib/menu';
import 'lib/datefns';
import 'lib/form';
import * as Utils from 'lib/utils';
import 'lib/global';

const UI = {};
const D = document;
const W = window;
const $D = $(D);
const $W = $(W);
let waitForAuth = true;

W.addEventListener('error', evt => {
  console.log('ERROR', evt);
});

$.fn.fixButtonGroups = function () {
  /* prettier-ignore */
  return $(this)
    .find('.btn-group')
    .each((idx, group) => {
      const $children = $(group).children('.btn').removeClass('first last');

      $children.filter(':visible:first').addClass('first');
      $children.filter(':visible:last').addClass('last');
    });
};

$.fn.swipe.defaults.excludedElements = '.modal, .select2-container, .iti--container, [data-sortable]';

$.fn.slideIn = function (params) {
  const $obj = $(this);

  return $obj.animate(
    {
      opacity: 'show',
    },
    {
      duration: params.duration,
      easing: params.easing,
      complete: params.complete,
      step: function (now) {
        $obj.css('transform', 'translateX(' + (1 - now) * 110 + '%)');
      },
    },
  );
};

$.fn.slideOut = function (params) {
  const $obj = $(this);

  return $obj.animate(
    {
      opacity: 'hide',
    },
    {
      duration: params.duration,
      easing: params.easing,
      complete: params.complete,
      step: function (now) {
        $obj.css('transform', 'translateX(' + (1 - now) * 110 + '%)');
      },
    },
  );
};

$D;

if (!$.events) $.events = { ui: [], auth: [] };

$.onInit = $.fn.onInit = function (handler) {
  $.events.ui.push([this, handler]);
  return this;
};

$.registerUI = (name, handlers) => {
  console.debug(`UI: Registering '${name}'...`);
  UI[name] = handlers;
};

$.initUI = async () => {
  console.debug('UI: Init...');
  $('body').initUI();
};

$.fn.initUI = function (...names) {
  if (names.length) {
    for (const name of names) {
      const ui = UI[name];
      if (ui && ui.init) ui.init.call(this);
    }

    return this;
  }

  for (const ui of Object.values(UI)) {
    if (ui && ui.init) {
      ui.init.call(this);
    }
  }

  return this;
};

$.fn.hideUI = function (...names) {
  if (names.length) {
    for (const name of names) {
      const ui = UI[name];
      if (ui && ui.hide) ui.hide.call(this);
    }

    return this;
  }

  for (const ui of Object.values(UI)) {
    if (ui && ui.hide) ui.hide.call(this);
  }

  return this;
};

$.waitFor = async (handler, timeout = 100) => {
  await new Promise(resolve => {
    (function wait() {
      if (handler()) resolve();
      setTimeout(wait, timeout);
    })();
  });
};

$.onInit(() => [import('lib/tooltip'), import('lib/popover')]);

const $body = $('body');
const query = Utils.parseQuery(location.search);
const updateOrientation = evt => {
  const [type, subtype] = ((evt ? evt?.target?.screen?.orientation : W?.screen?.orientation) || { type: 'portrait' }).type.split('-');
  $body
    .removeClass('portrait landscape')
    .addClass(type)
    .toggleClass('flipped', subtype === 'secondary');
};

$W.on('orientationchange', updateOrientation);
updateOrientation();

/* prettier-ignore */
$D
  .on('click', '.btn-back-to-parent', evt => {
    const isMobileDashboard = $(evt.target).closest('a').data('isMobileDashboard')
    if (!isMobileDashboard) {
      history.back();
      return false;
    }

  })
  .on('show.bs.collapse', '.page-menu', evt => {
    $(evt.currentTarget).find('.collapse.show').collapse('hide');
  });

D.onreadystatechange = () => {
  if (D.readyState === 'interactive') {
    (async () => {
      await $.initAuth();
      await Promise.all($.events.ui.map(([ctx, handler]) => handler.call(ctx)));
      waitForAuth = false;
    })();
  }

  if (D.readyState === 'complete') {
    (async () => {
      await $.waitFor(() => !waitForAuth);
      await $.initUI();
      await Promise.all($.events.auth.map(([ctx, handler]) => handler.call(ctx, W.AUTH)));
      if (W.navigation && W.navigation.canGoBack) $('.btn-back-to-parent').removeClass('d-none');
    })();
  }
};

if (query.scrollTo) {
  setTimeout(() => {
    $('.preserve-scroll').scrollTop(query.scrollTo);
  }, 100);
} else {
  $('.preserve-scroll').scrollTop(0);
}

const $form = $('form').find('.pane');
if ($form.length === 0) {
  $('.pane-content').on(
    'scroll',
    $.debounce(200, () => {
      const scrollTo = $('.pane-content').scrollTop();
      const query = '?' + Utils.toQuery({ scrollTo: scrollTo || null });

      window.history.replaceState('', '', query);
    }),
  );
}

if ($form.find('.preserve-scroll')) {
  $('.preserve-scroll').on(
    'scroll',
    $.debounce(200, () => {
      const scrollTo = $('.preserve-scroll').scrollTop();
      const query = '?' + Utils.toQuery({ scrollTo: scrollTo || null });

      window.history.replaceState('', '', query);
    }),
  );
}

export default $;
